export default __webpack_public_path__ + "static/media/call.0d35875b.svg";